import { Customer } from "./customer";
import { UserMgmtService } from "./../../_services/user-mgmt.service";
import { DOCUMENT } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ProjectData } from "src/app/_models/project-data";
import { ProjectService } from "src/app/_services/project.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { beatBlipSubscriptionConsts } from "src/app/consts/beatBlipSubscriptionConsts";
import { UserService } from "src/app/_services/user.service";
import { MemoryService } from "src/app/_services/memory.service";
import { HomeService } from "src/app/_services/home.service";

@Component({
  selector: "app-new-project",
  templateUrl: "./new-project.component.html",
  styleUrls: ["./new-project.component.scss"],
})
export class NewProjectComponent implements OnInit {
  projectCreateForm: UntypedFormGroup;
  currentUser: any;
  private userType: String;
  submitted = false;
  newProjectData: any;
  allProjectName: ProjectData[];
  url: string;
  curDate: any;
  masterUsers: any = [];
  dropdownSettings = {};
  customerList: any = [];
  userList: any = [];
  selectedItems: any = [];
  ImportForm: UntypedFormGroup;
  projectName: any;
  title: any;
  projectId: any;
  parentTestDataId: any;
  pName: string = "";
  Formfile: any;
  projectdata: any;
  fileType: string;
  enableUserList: boolean = false;
  projectZipName: boolean = false;
  prjName: any;
  selectedIcon: string = "AI";
  selectedColor: string = "Light Grey";
  // iconList = beatBlipSubscriptionConsts.iconList;
  // iconNames =  Object.keys(beatBlipSubscriptionConsts.iconList);
  iconList:any;
  iconNames:any;
  imageList:any;
  imageNames:any;
  colorList = beatBlipSubscriptionConsts.colorList;
  colorNames = Object.keys(beatBlipSubscriptionConsts.colorList);
  headerOptions = {
    showSetting: false,
    showSearch: false,
    heading: "New Automation",
    data: undefined,
  };
  agentCheck: boolean;
  ADOCheck =  localStorage.getItem('isADOEnabled') == 'true' ? true : false;
  createPermission: boolean = false;

  todayDate: any;
  icons: { AI: string; Banking: string; Healthcare: string; Technology: string; "Real estate": string; Retail: string; Insurance: string; "Supply chain": string; Hospitality: string; Finance: string; FMCG: string; Trade: string; Education: string; Media: string; Entertainment: string; Sales: string; Construction: string; Automobile: string; Telecom: string; Pharma: string; };
  

  constructor(
    private projectService: ProjectService,
    private formBuilder: UntypedFormBuilder,
    private toastrService: ToastrService,
    private userManagement: UserMgmtService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private memoryService: MemoryService,
    private homeService: HomeService,
    @Inject(DOCUMENT) private document: Document,
    private elRef: ElementRef
  ) {
    this.loadCurrentUser();
  }

  @ViewChild("randomeClick", null) randomeClick: ElementRef;

  ngOnInit() {
    this.homeService.setHeaderOptions(this.headerOptions);
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.todayDate = new Date();
    var nowDate = new Date();
    this.curDate =
      nowDate.getDate() +
      "/" +
      (nowDate.getMonth() + 1) +
      "/" +
      nowDate.getFullYear();

    this.loadForm();
    this.getAllImages();
    this.getAllIcons();
   
  }

  getAllImages() {
    try {
      this.http.get('assets/automation-images/images.json').subscribe(images => {
        this.imageList = images;
        this.imageNames = Object.keys(images);
        
        this.imageNames.forEach(key => {
          this.imageList[key] = "assets/automation-images/"+images[key];
        });

      }, error => {
        console.log("Error: ", error);
      });
    } catch (error) {

    }

  }

  getAllIcons() {
    try {
      this.http.get('assets/automation-images/icons.json').subscribe(icons => {
        this.iconList = icons;
        this.iconNames = Object.keys(icons);
  
      }, error=>{
        console.log("Error: ", error);
      });
    } catch (error) {

    }

  }

  sharedUserList() {
    if(!this.ADOCheck){
      this.selectedItems = this.userList;
    }
    else{
      this.selectedItems=[]
    }
  }

  loadCurrentUser()
  {
    this.userService.getUser().subscribe((res)=>
    {
      this.currentUser = res;
      this.loadUsers('automation');
    })
  }
regexStr = '^[a-zA-Z0-9_{}[]() ]+$'
  loadForm() {
    this.projectCreateForm = this.formBuilder.group({
      projectName: ["", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],],
      projectType: ["MIXED"],
      description: [""],
      date: [this.curDate],
    });
    let addNewField = this.ADOCheck ? this.projectCreateForm.addControl('adoIntId', this.formBuilder.control('')) : this.projectCreateForm.removeControl('adoIntId');
    this.submitted = false;
    this.selectedItems = [];
    this.selectedIcon = "AI";
    this.selectedColor = "Light Grey"
    this.projectZipName = false;
  }

  createProject() {
    this.submitted = true;
    if (this.projectCreateForm.invalid) {
      return;
    }
    
    var objFormval = this.projectCreateForm.value;
       objFormval.projectName = this.projectCreateForm.value.projectName.trim();
    if(objFormval.projectName.includes('_-_')){
      this.toastrService.clear();
      this.toastrService.warning('_-_ can not be used in the Automation Name');
      return;
    }
    if(this.imageList[this.selectedIcon] != null && this.imageList[this.selectedIcon] != "" && this.imageList[this.selectedIcon] != undefined) {
      objFormval['iconName'] = this.imageList[this.selectedIcon];
    } else {
      objFormval['iconName'] = this.iconList[this.selectedIcon];
    }
    // objFormval['iconName'] = this.iconList[this.selectedIcon];
    objFormval['color'] = this.selectedColor;
    this.projectService.addDefaultProject(objFormval).subscribe((data) => {
      var projectObject = data;
      console.log("data", projectObject["companyAccountId"]);
      if (data["id"] != null) {
        this.selectedItems.push({ userId: this.currentUser.id, sharedName: this.currentUser.name })
        this.selectedItems.forEach((e) => {
          e["companyAccountId"] = data["companyAccountId"];
          e["delete"] = true;
          e["execute"] = true;
          e["edit"] = true;
          e["view"] = true;
          e["projectName"] = data["projectName"];
          e["entityId"] = data["id"];
          e["projectType"] = data["projectType"];
        });
        let body = JSON.parse(JSON.stringify(this.selectedItems));
        let obj = {
          userRestriction: body,
        };
        console.log("Body == ", obj);
        this.userManagement.updateAccessManagement(obj).subscribe((res) => {
          this.selectedItems = [];
        });
        this.toastrService.clear();
        this.toastrService.success("Automation created successfully");
        this.submitted = false;
        if(this.agentCheck)
        {
          this.memoryService.setAllProjectsData([]);
        }
        else{
          localStorage.removeItem('allProjects');
        }
        this.loadForm();
        this.onReset();
      } else {
        this.toastrService.clear();
        this.toastrService.success(data["message"]);
      }
    });
  }

  loadUsers(param:any) {
    this.userManagement.loadUserData(param).subscribe((response) => {
      this.createPermission = true;
      this.masterUsers = response["masteruser"];
      for (let v of this.masterUsers) {
        this.customerList.push(v.customer);
      }
      for (let u of this.customerList) {
        if(this.currentUser.id != u.id)
        {
          this.userList.push({ userId: u.id, sharedName: u.name });
        }
      }
	  this.dropdownSettings = {
		singleSelection: false,
		idField: "userId",
		textField: "sharedName",
		selectAllText: "select All",
		unSelectAllText: "Unselect All",
		itemsShowLimit: 5,
		allowSearchFilter: true,
	  };
	  this.enableUserList = true;
	  this.randomeClick.nativeElement.click();
    });
  }

  onItemSelect(item: any) {
    console.log(item.id);
    var existId = this.selectedItems.filter((f) => f.userId === item.userId);
    console.log(existId);
    if (existId.length === 0) {
      this.selectedItems.push({
        userId: item.userId,
        sharedName: item.sharedName,
      });
    }

    console.log("selectedItems", this.selectedItems);
  }

  onSelectAll(items: any) {
    this.selectedItems = [];
    items.forEach((element) => {
      this.selectedItems.push({
        userId: element.userId,
        sharedName: element.sharedName,
      });
    });
  }

  public onDeSelect(item: any) {
    let index = this.selectedItems.findIndex((x) => x.userId === item.userId);

    delete this.selectedItems[index]
    console.log(this.selectedItems);
  }

  public onDeSelectAll(items: any) {
    this.selectedItems = [];
  }

  createAndUpload() {
    // this.loadUsers()
    if(!this.createPermission)
    {
      this.toastrService.clear();
      this.toastrService.error("You don't have permission to create automation");
      return;
    }

    if (this.Formfile === undefined) {
      this.createProject();
    } else {
      var objFormval = this.projectCreateForm.value;
      objFormval.projectName = this.projectCreateForm.value.projectName.trim();
      if(this.imageList[this.selectedIcon] != null && this.imageList[this.selectedIcon] != "" && this.imageList[this.selectedIcon] != undefined) {
        objFormval['iconName'] = this.imageList[this.selectedIcon];
      } else {
        objFormval['iconName'] = this.iconList[this.selectedIcon];
      }
      // objFormval["iconName"] = this.iconList[this.selectedIcon];
      objFormval["color"] = this.selectedColor;
      var objdata = objFormval;
    if(objFormval.projectName.includes('%')){
      this.toastrService.clear();
      this.toastrService.warning('% can not be used in the Automation Name');
      return;
    }
    
      this.ImportProject(objdata);
    }
  }

  get f1() {
    return this.projectCreateForm.controls;
  }

  onReset() {
    this.projectCreateForm.reset();
  }
 getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  
  objectKeyByValue (obj, val) {
    return Object.entries(obj).find(i => i[1] === val);
  }


  upload(files: File[]) {
    this.Formfile = files[0];
    if(files[0].name.includes('_-_')){

   
    var automationDetail = files[0].name.split('_-_');

    console.log(automationDetail);
    if(automationDetail.length>2){

      if(automationDetail[2].includes('fas')){
        var filterIcon =  automationDetail[2].substring(0, automationDetail[2].length - 4);
        this.icons = {
          "AI" : "fas fa-robot",
          "Banking": "fas fa-university",
          "Healthcare": "fas fa-medkit",
          "Technology": "fas fa-laptop",
          "Real estate": "fas fa-building",
          "Retail": "fas fa-store",
          "Insurance": "fas fa-heartbeat",
          "Supply chain": "fas fa-truck",
          "Hospitality" : "fas fa-praying-hands",
          "Finance": "fas fa-hand-holding-usd",
          "FMCG" :"fas fa-utensils",
          "Trade": "fas fa-chart-line",
          "Education": "fas fa-book-reader",
          "Media": "fas fa-bullhorn",
          "Entertainment": "fas fa-icons",
          "Sales": "fas fa-coins",
          "Construction" : "fas fa-tools",
          "Automobile": "fas fa-car",
          "Telecom": "fas fa-satellite-dish",
          "Pharma" : "fas fa-pills"
      }
      let startIndex = filterIcon.lastIndexOf('(');
      let endIndex = filterIcon.lastIndexOf(')');
      filterIcon =  startIndex != -1 ? filterIcon.replace(filterIcon.slice(startIndex, endIndex + 1), '').trim() : filterIcon;
      this.selectedIcon = this.getKeyByValue(this.icons,filterIcon);
      console.log(this.selectedIcon);
      
      }
      else{
        var filterIcon =  automationDetail[2].substring(25, automationDetail[2].length - 4) + '.png';
        console.log(filterIcon);
        const map = {
          "Andrew Autonomous" : "bot-andrew-autonomous-processing-agent-cropped.png",
          "Andy Account" : "bot-andy-account-mgmt-agent-cropped.png",
          "Betty Goodbuy": "bot-betty-goodbuy-purchasing-agent-cropped.png",
          "Catman Category": "bot-catman-category-mgmt-agent-cropped.png",
          "Collections Colleen": "bot-collections-colleen-collections-agent-cropped.png",
          "Danny Datadude": "bot-danny-datadude-data-integrity-agent-cropped.png",
          "Digital Daisy": "bot-digital-daisy-digital-commerce-agent-cropped.png",
          "Document Diana": "bot-document-diana-document-agent-cropped.png",
          "Freddy Fileman": "bot-freddy-fileman-file-agent-cropped.png",
          "Helpful Harry": "bot-helpful-harry-support-agent-cropped.png",
          "HR Hazel" : "bot-hr-hazel-hr-agent-cropped.png",
          "Kyc Katrina" : "bot-kyc-katrina-customer-agent-cropped.png",
          "Lending Leo" : "bot-lending-leo-loan-agent-cropped.png",
          "Loyalty Larry": "bot-loyalty-larry-loyalty-agent-cropped.png",
          "Mark Keting" :"bot-mark-keting-marketing-agent-cropped.png",
          "Merchandising molly": "bot-merchandising-molly-merchandising-agent-cropped.png",
          "Nancy Numbers": "bot-nancy-numbers-accounting-agent-cropped.png",
          "Ozzy Operations": "bot-ozzy-operations-agent-cropped.png",
          "Penny Priceright": "bot-penny-priceright-pricing-agent-cropped.png",
          "Polly Planner": "bot-polly-planner-finance-agent-cropped.png",
          "Randy Rainmaker" : "bot-randy-rainmaker-sales-agent-cropped.png",
          "Sammy Salesjump": "bot-sammy-salesjump-promotions-agent-cropped.png",
          "Sara Service": "bot-sara-service-customer-agent-cropped.png",
          "Stan Stockman" : "bot-stan-stockman-inventory-agent-cropped.png",
          "Tony Tester" : "bot-tony-tester-testing-agent-cropped.png",
          "Trent Truckswell" : "bot-trent-truckswell-transportation-agent-cropped.png",
          "Trudy Treasury" : "bot-trudy-treasury-agent-cropped.png"
      }
          let startIndex = filterIcon.lastIndexOf('(');
          let endIndex = filterIcon.lastIndexOf(')');
          filterIcon =  startIndex != -1 ? filterIcon.replace(filterIcon.slice(startIndex, endIndex + 1), '').split(' ').join('') : filterIcon;
          console.log(this.getKeyByValue(map,filterIcon));
          this.selectedIcon = this.getKeyByValue(map,filterIcon);
      }
   
      console.log(this.selectedIcon);
      this.selectedColor = automationDetail[1];
      console.log(this.colorNames);
      console.log(this.iconList);
      
      
    }
    else{
      this.selectedColor = automationDetail[1];
    }
    
    
    this.pName = automationDetail[0];
  }
  else{
    this.pName = files[0].name.substring(0, files[0].name.length - 4);
  }
    
    this.fileType = files[0].type;

    console.log("file", this.Formfile);
    this.projectZipName = true;
    // setTimeout(() => {
    // 	this.ImportProject(this.pName);
    // }, 1000);
  }

  ImportProject(name) {
    this.submitted = true;
    if (
      this.fileType != "application/x-zip-compressed" &&
      this.fileType != "application/zip"
    ) {
      this.toastrService.clear();
      this.toastrService.error("Only zip files are supported");
      return;
    }

    this.projectCreateForm.patchValue({
      projectName: name.ProjectName
    })

    this.prjImportFile(this.Formfile, name);
  }

  prjImportFile(file, projectName) {

    var fd = new FormData();
    fd.append("file", file);
    fd.append("projectName", JSON.stringify(projectName));
    this.toastrService.clear();
    this.toastrService.warning(
      'Please wait Automation uploading...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>',
      null,
      {
        extendedTimeOut: 0,
        timeOut: 0,
        enableHtml: true,
      }
    );
    this.submitted = false;
    this.projectService.importProject(fd).subscribe((data) => {
      console.log("data", data);

      var projectObject = data;
      console.log("data", projectObject["companyAccountId"]);
      if (data["id"] != null) {
        this.selectedItems.push({ userId: this.currentUser.id, sharedName: this.currentUser.name })
        this.selectedItems.forEach((e) => {
          e["companyAccountId"] = data["companyAccountId"];
          e["delete"] = true;
          e["edit"] = true;
          e["view"] = true;
          e["execute"] = true;
          e["projectName"] = data["projectName"];
          e["entityId"] = data["id"];
          e["projectType"] = data["projectType"];
        });
        let body = JSON.parse(JSON.stringify(this.selectedItems));
        let obj = {
          userRestriction: body,
        };
        this.userManagement.updateAccessManagement(obj).subscribe((res) => {
          this.selectedItems = [];
        });
        this.toastrService.clear();
        this.projectService.loadSuggestion.next(true);
        if(this.agentCheck)
        {
          this.memoryService.setAllProjectsData([]);
        }
        else{
          localStorage.removeItem('allProjects');
        }
        this.toastrService.success("Automation imported successfully");
        this.submitted = false;
        this.onReset();
        this.loadForm();
      } else {
        this.toastrService.clear();
        this.toastrService.success(data["message"]);
      }
    });
  }
}
